<template>
  <div
    v-for="banner in visibleBanners"
    :key="banner.campaign_key"
    class="relative w-full bg-red-4 dark:bg-dark-red-soft lg:text-center py-2 px-4 lg:h-auto flex items-center"
  >
    <p class="text-red-2 dark:text-dark-red font-semibold text-xs lg:text-base grow pr-8">
      {{ banner.body }}
      <a
        v-if="banner.button_href && banner.button_text"
        :href="banner.button_href"
        target="_blank"
        rel="noreferrer"
        class="underline"
      >
        {{ banner.button_text }}
      </a>
    </p>
    <AppButton
      theme="inherit"
      rounded
      icon="close"
      class="text-red-2 dark:text-dark-red"
      aria-label="Dismiss notification"
      @click="dismissBanner(banner)"
    >
    </AppButton>
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { useUserStore } from '@/stores/userStore.js'
import { useBannerAdvertisements } from '@/composables/useAdvertisements'

const userStore = useUserStore()

const { banners, visibleBanners, fetchActiveBanners, dismissBanner } =
  useBannerAdvertisements()

watch(
  () => userStore.isAuthenticated,
  (isAuthenticated) => {
    if (isAuthenticated && !banners.value.length) {
      fetchActiveBanners()
    }
  },
  { immediate: true }
)
</script>
